import React from 'react';
import { string, func } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';

import TextArea from '../../ui-kit/TextArea';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    width: '100%',
    border: `2px solid ${theme.palette.neutral.light}`,
    borderRadius: 10,
    boxShadow: 'none',
    margin: '0 auto',
    [theme.breakpoints.up('md')]: {
      width: 600,
    },
  },
  notesLabel: {
    fontWeight: 600,
  },
}));

const Notes = ({ notes, setNotes }) => {
  const classes = useStyles();

  return (
    <Card
      classes={{
        root: classes.cardRoot,
      }}
    >
      <Box pt={2} pr={3} pb={1} pl={3}>
        <Typography variant="body2" classes={{ root: classes.notesLabel }}>
          Notes for the team:
        </Typography>
        <TextArea
          charLimit={4000}
          numRows={6}
          onChange={setNotes}
          title="Ex. loading, unloading, furniture rearranging, garage re-organization, home staging, and/or event setup/clearing."
          value={notes}
          outlined={false}
          color="secondary"
        />
      </Box>
    </Card>
  );
};

Notes.propTypes = {
  notes: string.isRequired,
  setNotes: func.isRequired,
};

Notes.defaultProps = {};

export default Notes;
